export default "__VITE_ASSET__BIXVQi7k__"